import React from "react";
import PropTypes from "prop-types";
import classes from "./FormattedTextPrice.module.css";

export const FormattedTextPrice = ({ cents }) => {
  const dollars = Math.floor(cents / 100);
  const centsPart = (cents % 100).toString().padStart(2, '0');
  const dollarsFormatted = dollars.toLocaleString('en-US');

  return (
    <span className={classes.container}>
      <span className={classes.dollars}>${dollarsFormatted}.</span>
      <span className={classes.cents}>{centsPart}</span>
    </span>
  );
};

FormattedTextPrice.propTypes = {
  className: PropTypes.string,
  cents: PropTypes.number.isRequired
};
